export default "__VITE_ASSET__CVqmGy7M__"